export enum BarLayoutSection {
    Utilities,
    MenuActionBarTopLeft,
    MenuActionBarTopRight,
    ActionBarTopLeft,
    ActionBarTopRight,
    MenuTop,
    ContentActionBarTopRight,
    ContentActionBarBottomRight,
    MenuBottom,
    MenuActionBarBottomLeft,
    MenuActionBarBottomRight,
    ActionBarBottomLeft,
    ActionBarBottomRight,
    GlobalHeaderRight,
    TitleMeta
}
